import React, { useState, useRef } from 'react';
import { injectIntl } from 'react-intl';
import { Formik } from 'formik';
import { useViewlogies } from 'context';
import {
    getGuestCookie,
    setGuestCookie,
    getGuestVariantCookie,
    setViewerContactCookie,
    insertGuest,
} from 'services/guest';
import './guestForm.scss';
import { FormattedMessage } from 'react-intl';
import { FadeLoader } from 'react-spinners';
import SubmissionForm from './SubmissionForm';
import Header from './Header';
// import isEventStarted from './isEventStarted';
import RedirectButton from './RedirectButton';
import CypressLawnButton from './CypressLawnButton';

const GuestForm = ({ intl, isRsvpForm = false }) => {
    const {
        event: { id, organizationId, firstName, lastName, color, obituaryUrl, organizationName },
        fetchGuestList,
        streams,
    } = useViewlogies();

    // const eventStarted = isEventStarted(streams);

    const [message, setMessage] = useState('');
    const [isRecaptchaError, setIsRecaptchaError] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(getGuestCookie(id) === 'true');
    const variant = getGuestVariantCookie();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const showCypressLawnButton = organizationName === 'Cypress Lawn' && !!obituaryUrl;

    const recaptchaRef = useRef();

    const loaderStyles = `
        margin-left: 20px;
    `;

    return (
        <div className="guest-form-wrapper">
            <section className="guest-form-container">
                <Header
                    intl={intl}
                    lastName={lastName}
                    isRsvpForm={isRsvpForm}
                    color={color}
                    isFormSubmitted={isFormSubmitted}
                    isSubmitting={isSubmitting}
                />
                {isFormSubmitted || isSubmitting ? (
                    <div className="guest-form-description" color={color}>
                        {isSubmitting ? (
                            <div className="submission-loader-container">
                                <FadeLoader
                                    color={'#646464'}
                                    margin={-5}
                                    height={10}
                                    width={3}
                                    radius={1}
                                    css={loaderStyles}
                                />
                            </div>
                        ) : !isRsvpForm ? (
                            <div className="guest-form-end-message">
                                <FormattedMessage
                                    id="features.Viewlogy.GuestSection.Form.nameAdded"
                                    defaultMessage="Your name has been added to the Guest List..."
                                />
                                <RedirectButton intl={intl} color={color} hash="stream" />
                                {showCypressLawnButton && <CypressLawnButton obituaryUrl={obituaryUrl} color={color} />}
                            </div>
                        ) : (
                            <>
                                <FormattedMessage
                                    id="features.Viewlogy.GuestSection.Form.rsvpNameAdded"
                                    defaultMessage={`Your name has been added to the RSVP List...`}
                                />
                                {showCypressLawnButton && <CypressLawnButton obituaryUrl={obituaryUrl} color={color} />}
                            </>
                        )}
                    </div>
                ) : (
                    <>
                        <Formik
                            initialValues={{ name: '', email: '', abVariant: variant, preplanningInterest: false }}
                            onSubmit={async values => {
                                setMessage('');
                                const token = await recaptchaRef.current.getValue();
                                if (!token) {
                                    setIsRecaptchaError(true);
                                } else {
                                    setIsRecaptchaError(false);
                                    setMessage('');
                                    setIsSubmitting(true);
                                    const { status } = await insertGuest(id, organizationId, values, token);
                                    if (status === 201) {
                                        setGuestCookie(id);
                                        setViewerContactCookie({ name: values.name, email: values.email });
                                        await fetchGuestList();
                                        setIsSubmitting(false);
                                        setIsFormSubmitted(true);
                                    } else {
                                        console.error('There was an error', status);
                                        setMessage(
                                            intl.formatMessage({
                                                id: 'features.Viewlogy.GuestSection.Form.error',
                                                defaultMessage: 'There was an error, please try again.',
                                            }),
                                        );
                                    }
                                }
                            }}
                        >
                            {({ values, touched, isSubmitting }) => (
                                <SubmissionForm
                                    values={values}
                                    touched={touched}
                                    isSubmitting={isSubmitting}
                                    recaptchaRef={recaptchaRef}
                                    setMessage={setMessage}
                                    isRecaptchaError={isRecaptchaError}
                                    message={message}
                                    intl={intl}
                                    color={color}
                                />
                            )}
                        </Formik>
                    </>
                )}
            </section>
        </div>
    );
};

export default injectIntl(GuestForm);
